import React from "react";

import { Helmet } from "react-helmet";

import Header from "../components/header";
import SecondaryButton from "../components/secondary-button";
import Footer from "../components/footer";
import Images from "../components/Images/Images";
import "./gallery.css";

const Gallery = (props) => {
  return (
    <div className="coming-soon-container">
      <Helmet>
        <title>Gallery - MabiVCC</title>
        <meta
          property="og:title"
          content="Gallery - Mabinogi Visual Chat Converter"
        />
      </Helmet>
      <Header></Header>
      <div className="coming-soon-container1">
        <div
          style={{
            paddingTop: "75px",
          }}
        >
          <div
            id="gallery"
            style={{
              paddingTop: "50px",
            }}
          >
            <Images></Images>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Gallery;
